"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterSuggestions = void 0;
const removeDiacritics_1 = require("./removeDiacritics");
const filterSuggestions = (suggestions, query) => {
    const normalizeString = (str) => (0, removeDiacritics_1.removeDiacritics)(str.toLowerCase());
    const normalizedSuggestions = suggestions
        .map(suggestion => ({
        normalized: normalizeString(suggestion),
        matching: normalizeString(suggestion).indexOf(normalizeString(query)),
        suggestion,
    }))
        .filter(({ matching }) => matching !== -1)
        .sort((s1, s2) => (s1.matching < s2.matching ? -1 : 1));
    return normalizedSuggestions.map(s => s.suggestion);
};
exports.filterSuggestions = filterSuggestions;
//# sourceMappingURL=filterSuggestions.js.map